import { Observable } from 'rxjs'
import { OrgLevelModel } from '../models/orgLevelModel'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { OrganizationModel } from '../models/OrganizationModel'
import { CagPlan } from '../models/cagplan'
import { CagFilter } from '../models/cag-filter'
import { AddPlanToOrgModel } from '../models/add-plan-to-org'
import { OrgListData } from '../models/org-list-data'
import { VwOrgLevelDetails } from '../models/view-orglevel-details'
import { GetOrgList } from '../models/get-org-list'

export abstract class OrgLevelGateway {
    abstract getOrgLevelDetails(parent: number): Observable<OrgLevelModel[]>
    abstract getOrgListDataSync(getOrgList: GetOrgList): OrgListData[]

    abstract getOrgListData(getOrgList: GetOrgList): Observable<OrgListData[]>
    abstract getAllStates(): Observable<ValidatedSelectOptionModel[]>
    abstract getNotAddedStates(orgId: number): Observable<ValidatedSelectOptionModel[]>
    abstract getFMO(): Observable<ValidatedSelectOptionModel[]>
    abstract addFMO(FMODetails: OrganizationModel): Observable<number>
    abstract getCAGPlans(filterData: CagFilter): Observable<CagPlan[]>
    abstract getCAGPlansSync(filterData: CagFilter): CagPlan[]
    abstract addPlans(planModel: AddPlanToOrgModel[]): Observable<number>
    abstract getOrgDetailsByOrgID(orgId: number): Observable<VwOrgLevelDetails>
    abstract getMarketingType(orgid: any): Observable<ValidatedSelectOptionModel[]>
    abstract getInsuranceCoOrgID(coOrgID: number): Observable<number>
    abstract getOrgListByOrgName(orgName: string): Observable<OrgListData[]>
}
